import { ExcelStyle } from 'ag-grid-community';

export function getExcelStyles(fontSize: number = 11): ExcelStyle[] {
  return [
    { id: 'ag-grid-cell-center', font: { color: '#000000', size: fontSize }, alignment: { horizontal: 'Center' } },
    { id: 'text-center', font: { color: '#000000', size: fontSize }, alignment: { horizontal: 'Center' } },
    { id: 'ag-right-aligned-header', font: { color: '#000000', size: fontSize }, alignment: { horizontal: 'Right' } },
    { id: 'ag-grid-cell-right', font: { color: '#000000', size: fontSize }, alignment: { horizontal: 'Right' } },
    { id: 'header', font: { color: '#000000', size: fontSize } },
    { id: 'cell', font: { color: '#000000', size: fontSize } },
    { id: 'default-cell-class', font: { color: '#000000', size: fontSize } }
  ];
}
